require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-foods-that-make-our-bellies-rounder.json") })
        }
      }, "path---blog-foods-that-make-our-bellies-rounder");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-foods-that-make-our-bellies-rounder!./.cache/json/blog-foods-that-make-our-bellies-rounder.json
// module id = 289
// module chunks = 231608221292675